/**
 * Created by Rodrigo Quesada on 03/05/17.
 */
import {Model} from '../../../domain/model/common/model.class';
import {Profile} from '../../../domain/model/profile/profile.model';
import ProjectionInformation = Model.ProjectionInformation;

export type IdentificationInfoProjectionType = Model<Profile> & Pick<Profile, 'birth' | 'driverLicense' | 'ssn' | 'npi' | 'work'> ;

export const IdentificationInfoProjection = new ProjectionInformation('identificationInfo');



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/personal-details/model/identification-info.model.ts